const initialState = [];

function reducer(state = initialState, action) {
    if (action.type === 'ISSUE_PARTNER_EVALUATIONS_SUCCESS') {
        return action.payload;
    }

    return state;
}

export default reducer;
